import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllGuardians as apiFn } from "../../api/apiGuardians";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useForceDeleteAllGuardians() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteAllGuardians, isPending: isForceDelete } = useMutation({ mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["guardians"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { forceDeleteAllGuardians, isForceDelete }; }
